import { createSlice } from '@reduxjs/toolkit';

export const paymentdetailSlice = createSlice({
  name: 'paymentdetails',
  initialState: {
    data: [],
  },
  reducers: {
    setPayment: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setPayment} = paymentdetailSlice.actions;

export default paymentdetailSlice.reducer;
